export enum LazoTeamMemberRoles {
  SUPER_ADMIN = "SUPER_ADMIN",
  KAM = "KAM",
  Standard = "STANDARD",
  LAZO_USER = "LAZO_USER",
  LAZO_TEAM_ADMIN = "LAZO_TEAM_ADMIN",
}
